"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAffiliateTracker = useAffiliateTracker;
var _react = require("react");
var _affiliateTracker = _interopRequireDefault(require("./affiliate-tracker"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// adding script tags
function useAffiliateTracker(domains, targetElement) {
  (0, _react.useEffect)(() => {
    const onPageLoad = () => {
      (0, _affiliateTracker.default)(domains, targetElement);
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, [domains, targetElement]);
}